import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { UIModule } from '@c4/ui';

import { ProgrammingCommonModule } from '../../common/common.module';
import { QuickstartCommonModule } from '../quickstart-common/quickstart-common.module';

import { QSSimpleService } from './quickstart-simple.service';

import { QSSimpleComponent } from './quickstart-simple.component';
import { QSSimpleSelectDeviceComponent } from './select-device/select-device.component';
import { QSSimpleSelectEventComponent } from './select-event/select-event.component';
import { QSSimpleSelectActionComponent } from './select-action/select-action.component';
import { QSSimpleSelectParamsComponent } from './select-params/select-params.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    UIModule,
    ProgrammingCommonModule,
    QuickstartCommonModule
  ],
  declarations: [
    QSSimpleComponent,
    QSSimpleSelectDeviceComponent,
    QSSimpleSelectEventComponent,
    QSSimpleSelectActionComponent,
    QSSimpleSelectParamsComponent
  ]
})
export class QuickstartSimpleModule { }



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/quickstart-simple.module.ts